import { render, staticRenderFns } from "./TelaGrupo.vue?vue&type=template&id=62b6c250&"
import script from "./TelaGrupo.vue?vue&type=script&lang=js&"
export * from "./TelaGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports